import styles from "./Filters.module.scss";
import SearchFilter from "../../../SearchFilter/SearchFilter";
import ObjectTypeFilter from "./FilterTypes/FilterTypes";
import CCFilter from "./CCFilter/CCFilter";
import DateFilter from "./DateFilter/DateFilter";
import OtherFilters from "./OtherFilters/OtherFilters";
import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import DatasetsDropdown from "../../_mapFilterComponents/DatasetsDropdown/DatasetsDropdown";
import RegionDropdown from "../RegionDropdown/RegionDropdown";
import { useMediaQuery } from "react-responsive";
import { breakpoints } from "../../../../constants";
import ClearAllFiltersDesktopButton from "../../../../share/filters/ClearAllFiltersDesktopButton";
import MobileClearAllButton from "../../../../share/filters/MobileClearAllButton";

import SavedFilters from "../../../templates/SavedFilters";
import AddSavedFilters from "../../../templates/AddSavedFilters";
import { FilterGroup, SearchWrapper } from "../../../../share/filters";
import styled from "@emotion/styled";
import { UserProfileListControls } from "../../../UserProfileBar/UserProfileBar";
import { icons } from "../../../../constants";
import {
  ListViewActions,
  ListViewFilterGroup,
  ListViewSearchRow,
  ListViewSearchSection,
  ListViewSearchWrapper,
  ListViewTopContainer,
  MapToggleButton,
} from "../../shared/ListViewLayout";

export const FiltersWrapper = styled.div<{ isListView?: boolean }>`
  display: grid;
  padding: ${(props) =>
    props.isListView ? "24px 24px 16px" : "32px 24px 24px 24px"};
  border-bottom: 1px solid var(--fourth-black-color);
  row-gap: ${(props) => (props.isListView ? "16px" : "0")};
  @media (max-width: ${breakpoints.medium}px) {
    padding: ${(props) => (props.isListView ? "16px" : "16px 0 8px")};
  }
  @media (max-width: ${breakpoints.small}px) {
    padding: ${(props) => (props.isListView ? "16px" : "16px 0 8px")};
  }
`;

interface FiltersProps {
  isListView?: boolean;
}

const Filters = ({ isListView = false }: FiltersProps) => {
  const { config } = useTypedSelector((state) => state.mapObjectsInfo);

  const { setCleanAllFilters, getDefaultResult, setIsListViewActive } =
    useActions();

  const handleClean = () => {
    setCleanAllFilters();
    getDefaultResult();
  };

  const handleShowMap = () => {
    setIsListViewActive(false);
  };

  const isMobile = useMediaQuery({
    query: `(max-width: ${breakpoints.medium}px)`,
  });

  const SearchWrapperComponent = isListView
    ? ListViewSearchWrapper
    : SearchWrapper;

  const renderFilters = (WrapperComponent: typeof FilterGroup) => (
    <WrapperComponent onClick={(event) => event.stopPropagation()}>
      {config?.filters?.types ? <ObjectTypeFilter /> : ""}
      {config?.filters?.cc ? <CCFilter /> : ""}
      {config?.filters?.date ? <DateFilter /> : ""}
      {config?.filters?.other ? <OtherFilters /> : ""}
      <MobileClearAllButton onClick={handleClean} />
    </WrapperComponent>
  );

  const shouldRenderListView = isListView && !isMobile;

  return (
    <FiltersWrapper isListView={shouldRenderListView}>
      {shouldRenderListView ? (
        <>
          <ListViewTopContainer>
            <div className={styles.regionsDatasetsWrapper}>
              <RegionDropdown />
              <DatasetsDropdown />
            </div>
            <ListViewActions>
              <SavedFilters isDisabled={false} />
              <AddSavedFilters />
              <UserProfileListControls />
            </ListViewActions>
          </ListViewTopContainer>
          <ListViewSearchSection>
            <ListViewSearchRow>
              <MapToggleButton
                type="button"
                onClick={handleShowMap}
                aria-label="Show map view"
              >
                <img src={icons.NavMapIcon} alt="Show map view" />
              </MapToggleButton>
              <ListViewSearchWrapper>
                <SearchFilter />
              </ListViewSearchWrapper>
              {renderFilters(ListViewFilterGroup)}
            </ListViewSearchRow>
          </ListViewSearchSection>
        </>
      ) : (
        <>
          <div className={styles.topContainer}>
            <div className={styles.regionsDatasetsWrapper}>
              <RegionDropdown />
              <DatasetsDropdown />
            </div>

            <div className={styles.topContainerButtons}>
              <SavedFilters isDisabled={false} />
              <AddSavedFilters />
            </div>
          </div>
          <SearchWrapperComponent>
            <SearchFilter />
          </SearchWrapperComponent>
          {renderFilters(FilterGroup)}
        </>
      )}

      {!isMobile && <ClearAllFiltersDesktopButton onClick={handleClean} />}
    </FiltersWrapper>
  );
};

export default Filters;
